enum PdfaDialogFields {
	FORMAT = "format",
	RESOLUTION = "resolution",
	ERROR_CORRECTION = "error_correction",
	ZUGFERD = "zugferd",
	FILE = "file",
	VERSION = "version",
}

export default PdfaDialogFields;